import React from 'react';

import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { HistoryItem } from '@components/learning/Searchbar/children/HistoryItem/HistoryItem';
import { media } from '@atlaskit/primitives/responsive';

interface SearchbarHistoryProps {
  items: string[];
  onRemove: (item: string) => void;
  onSelect: (selectedItem: string) => void;
}

export const SearchbarHistory = ({ items, onRemove, onSelect }: SearchbarHistoryProps): React.ReactElement => {
  if (!items.length) {
    return <></>;
  }

  return (
    <div css={historyStyles} data-testid="history-container">
      {items
        .slice(-5)
        .reverse()
        .map((item) => (
          <HistoryItem key={item} item={item} onRemove={onRemove} onSelect={onSelect} />
        ))}
    </div>
  );
};

const historyStyles = css({
  position: 'absolute',
  display: 'flex',
  width: '279px',
  borderRadius: '3px',
  padding: `${token('space.075')} ${token('space.050')}`,
  marginTop: token('space.075'),
  flexDirection: 'column',
  alignItems: 'flex-start',
  background: token('elevation.surface.overlay'),
  boxShadow: token('elevation.shadow.overlay'),
  zIndex: 1,

  [media.below.md]: {
    width: '327px',
  },
});
